import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material';
declare var createjs:any;
import { SessionService } from '../../shared/services/session.service';

@Component({
  selector: 'app-borjor',
  templateUrl: './borjor.component.html',
  styleUrls: ['./borjor.component.scss']
})

export class BorjorComponent implements OnInit {

  public bloburl: string;
  private stage: any;
  constructor(private sessionService: SessionService, public thisDialogRef: MatDialogRef<BorjorComponent>, @Inject(MAT_DIALOG_DATA) public data: string) {

    this.bloburl = this.sessionService.bloburl;
  }

  ngOnInit() {
    var stage = new createjs.Stage("yr3_canvas");
    this.stage = stage;
   
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    if (!isIOS) {
      createjs.Touch.enable(stage);
    }

    var yr3_canvas: any = document.getElementById('yr3_canvas');
    yr3_canvas.width = 1785;
    yr3_canvas.height = 890;

    //frame
    var yr3_bitmap = new createjs.Bitmap(this.bloburl + "/Lasresan/AK3/YR3-Tincan/borjor/frame.png");
    yr3_bitmap.setTransform(0, 0, 0.992, 0.97);

    //2 or 3 selection container

    var option_container = new createjs.Container();

    var img_rect = new createjs.Shape();
    img_rect.graphics.setStrokeStyle(2).f('#FFFFFF').beginStroke("#ED8505").setStrokeDash([6, 6]).drawRoundRect(0, 0, 199, 93, 10);
    img_rect.setTransform(97, 95);

    var text1 = new createjs.Text("Korta börjor", "23px Arial", "#000000");
    text1.setTransform(150, 113);

    var text2 = new createjs.Text("Långa börjor", "23px Arial", "grey");
    text2.setTransform(150, 153.5);

    option_container.addChild(img_rect, text1, text2);

    //static notepad, pencil imzages

    var yr3_borjornotepad = new createjs.Bitmap(this.bloburl + "/Lasresan/AK3/YR3-Tincan/borjor/yr3_borjornotepad.png");
    yr3_borjornotepad.setTransform(600, 180);

    var yr3_pencil = new createjs.Bitmap(this.bloburl + "/Lasresan/AK3/YR3-Tincan/borjor/yr3_pencil.png");
    yr3_pencil.setTransform(1060, 280);

    var heading = new createjs.Text("Börjor", "bold 60px Dk-mariken", "#FF0000");
    if (isIOS) {

      var heading = new createjs.Text("Börjor", "60px Dk-mariken", "#FF0000");
      heading.outline = 2;

      var heading_ipad = new createjs.Text("Börjor", "60px Dk-mariken", "#FF0000");
      heading_ipad.textAlign = "center";
      heading_ipad.setTransform(890, 80);

    }  
    heading.textAlign = "center";
    heading.setTransform(890, 80);   

    //to select 2 or 3 image option

    var img_rect1: any = new createjs.Shape();
    img_rect1.overColor = "#ED8505";
    img_rect1.outColor = "#FFFFFF";
    img_rect1.graphics.setStrokeStyle(1).beginFill(img_rect1.outColor).beginStroke("#000000").drawCircle(0, 0, 10);
    img_rect1.setTransform(125, 123);
    img_rect1.cursor = 'pointer';
    img_rect1.name = "Onebilder";
    img_rect1.visible = true;
    img_rect1.addEventListener("click", startfirstexercise);

    var img_temprect1: any = new createjs.Shape();
    img_temprect1.overColor = "#ED8505";
    img_temprect1.outColor = "#FFFFFF";
    img_temprect1.graphics.setStrokeStyle(1).beginFill(img_temprect1.overColor).beginStroke("#000000").drawCircle(0, 0, 10);
    img_temprect1.setTransform(125, 123);
    img_temprect1.cursor = 'pointer';
    img_temprect1.name = "Onebilder";
    img_temprect1.visible = false;

    var img_rect2: any = new createjs.Shape();
    img_rect2.overColor = "#ED8505";
    img_rect2.outColor = "#FFFFFF";
    img_rect2.graphics.setStrokeStyle(1).beginFill(img_rect2.outColor).beginStroke("#000000").drawCircle(0, 0, 10);
    img_rect2.setTransform(125, 163);    
    img_rect2.name = "Twobilder";
    img_rect2.addEventListener("click");

    var img_temprect2: any = new createjs.Shape();
    img_temprect2.overColor = "#ED8505";
    img_temprect2.outColor = "#FFFFFF";
    img_temprect2.graphics.setStrokeStyle(1).beginFill(img_temprect2.overColor).beginStroke("#000000").drawCircle(0, 0, 10);
    img_temprect2.setTransform(125, 163);    
    img_temprect2.name = "Twobilder";
    img_temprect2.visible = false;

    startfirstexercise();

    function shuffle(obj1, obj2) {
      var index = obj1.length;
      var rnd, tmp1, tmp2;

      while (index) {
        rnd = Math.floor(Math.random() * index);
        index -= 1;
        tmp1 = obj1[index];
        tmp2 = obj2[index];
        obj1[index] = obj1[rnd];
        obj2[index] = obj2[rnd];
        obj1[rnd] = tmp1;
        obj2[rnd] = tmp2;
      }
    }

    function startfirstexercise() {

      for (var j = 0; j < stage.children.length; j++) {
        if (stage.children[j].name == "removeimage") {
          stage.removeChild(stage.children[j]);
          j = j - 1;
        }
      }

      img_rect1.visible = false;
      img_temprect1.visible = true;
      img_rect2.visible = true;
      img_temprect2.visible = false;

      img_rect1.graphics.clear().setStrokeStyle(1).beginFill(img_rect1.overColor).beginStroke("#000000").drawCircle(0, 0, 10).endFill();
      img_rect2.graphics.clear().setStrokeStyle(1).beginFill("#FFFFFF").beginStroke("#000000").drawCircle(0, 0, 10).endFill();
 
      var sb: any = [0, 1, 2, 3, 4, 5, 6,
        7, 8, 9, 10, 11, 12, 13,
        14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27,
        28, 29, 30, 31, 32, 33, 34,
        35, 36, 37, 38, 39
      ];

      shuffle(sb, sb);      

      var writingtextarray = [
        "Har någon sett ...",
        "En farlig ...",
        "Min cykel ...",
        "Ikväll kommer ...",
        "Min faster ...",
        "I meddelandet stod ...",
        "En varm sommardag ...",
        "Strax före midnatt ...",
        "Jag behöver ...",
        "Polisen tog ...",

        "Efter rasten ...",
        "Jag vill ...",
        "Jag önskar ...",
        "På festen ...",
        "På vintern ...",
        "Då hörde vi ett ...",
        "Uppe på toppen ...",
        "Min idol ...",
        "Akta dig för ...",
        "Varför köpte ...",

        "Min mobil ...",
        "I vår bil ...",
        "Under min säng ...",
        "Där kröp ...",
        "En läskig ...",
        "På gräset ...",
        "Bussen kom ...",
        "I soppan hittade ...",
        "Vågorna var ...",
        "Plötsligt välte ...",

        "På min födelsedag ...",
        "Bakom julgranen ...",
        "I sommar vill ...",
        "Världens högsta ...",
        "Den coolaste ...",
        "Den bästa ...",
        "Chokladbollarna smakade ...",
        "På träningen ...",
        "När dataspelet ...",
        "Getingen flög rakt ..."
      ];

      stage.addChild(yr3_borjornotepad, yr3_pencil);

      var yr3_exercisecount = 0;
     
      borjor(0);       

      function borjor(yr3_exercisecount) {
        
        var dynamic_ques1: any = new createjs.Text(writingtextarray[sb[yr3_exercisecount]], "35px MyriadPro-Regular", "#000000");
        dynamic_ques1.setTransform(650, 280);
        dynamic_ques1.name = "removeimage";            
        stage.addChild(dynamic_ques1);
      }

      img_temprect1.addEventListener("click", function () {
        for (var j = 0; j < stage.children.length; j++) {
          if (stage.children[j].name == "removeimage") {
            stage.removeChild(stage.children[j]);
            j = j - 1;
          }
        }
        yr3_exercisecount = yr3_exercisecount + 1;
        if (yr3_exercisecount == 40) {
          yr3_exercisecount = 0;
          shuffle(sb, sb);  
          borjor(yr3_exercisecount);
        } else {
          borjor(yr3_exercisecount);
        }
        
      });         
    }



    function startsecondexercise() {

      for (var j = 0; j < stage.children.length; j++) {
        if (stage.children[j].name == "removeimage") {
          stage.removeChild(stage.children[j]);
          j = j - 1;
        }
      }

      img_rect1.visible = true;
      img_temprect1.visible = false;
      img_rect2.visible = false;
      img_temprect2.visible = true;
      
      img_rect1.graphics.clear().setStrokeStyle(1).beginFill("#FFFFFF").beginStroke("#000000").drawCircle(0, 0, 10).endFill();
      img_rect2.graphics.clear().setStrokeStyle(1).beginFill(img_rect2.overColor).beginStroke("#000000").drawCircle(0, 0, 10).endFill();

      var sb: any = [0, 1, 2, 3, 4, 5, 6,
        7, 8, 9, 10, 11, 12, 13,
        14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27,
        28, 29, 30, 31, 32, 33, 34,
        35, 36, 37, 38, 39
      ];

      shuffle(sb, sb);      

      var writingtextarray = [
        "Tyvärr var det inte kanel i bullarna",
        "När din största idol ringer dig ...",
        "När berg och dalbanan du åker i",
        "När du öppnar din pizzakartong",
        "Jag träffade en rallyförare som ...",
        "Plötsligt en dag, så är ingenting sig",
        "Din lärare har börjat ta med sig ...",
        "När du firar din födelsedag",
        "När ditt nya dataspel plötsligt ...",
        "Djuren på zoo gör uppror mot ...",

        "Om jag får välja vad jag vill göra",
        "Känslan i kroppen när du bestigit",
        "När du får frågan om att vara med i",
        "När det som inte får hända ändå",
        "Du svarar inte när det ringer i",
        "Den envisa flugan kryper in i",
        "Sladden till din dator börjar",
        "Det har landat ett mystiskt föremål",
        "Plötsligt började köttbullarna i",
        "Jag beställde den största glassen,",


        "Rödpandan hade rymt från zoo och",
        "I stallet stod det 14 hästar och 1 ...",
        "I ödetorpet började det plötsligt att",
        "Idag fick jag vara hemma från",
        "Det här måste vara min turdag",
        "När du hittar personen som har ätit",
        "Om du vågar smaka på den här",
        "Om jag skulle ställa upp i Talang så",
        "Av alla knäppa förslag så var det",
        "Jag klev av vid hållplatsen för att",



        "Det värsta jag har gjort i mitt liv",
        "Jag har tappat bort nyckeln till ...",
        "Rektorn har blivit alldeles tokig och",
        "En gång var jag ensam hemma när",
        "När jag skulle cykla hem upptäckte",
        "Oh no, du har glömt att hämta",
        "Den här är en efterlysning av ...",
        "Om vi inte hinner innan midnatt",
        "När vi packade upp resväskan såg",
        "Det var ett stort snabbt och svart"
      ];


      var writingtextarray1 = [
        "utan ...",
        "",
        "plötsligt ...",
        "och upptäcker ...",
        "",
        "likt ...",
        "",
        "tillsammans med ...",
        "",
        "",

        "under en dag så ...",
        "Kebnekaise ...",
        "ett tv-program ...",
        "händer ...",
        "telefonen eftersom ...",
        "din ...",
        "plötsligt att ...",
        "i lekparken som ...",
        "stekpannan att ...",
        "men fick ...",

        "hittades ...",
        "",
        "ryka från ...",
        "skolan eftersom ...",
        "eftersom ...",
        "upp allt ditt godis ...",
        "röran så ...",
        "skulle jag ...",
        "här det ...",
        "träffa ...",

        "är ...",
        "",
        "bestämt ...",
        "det blev strömavbrott ...",
        "jag att någon hade ...",
        "lillasyster på förskolan ...",
        "",
        "så ...",
        "vi att ...",
        "djur som ..."
      ];

      stage.addChild(yr3_borjornotepad, yr3_pencil);

      var yr3_exercisecount = 0;

      inspiration(0);

      function inspiration(yr3_exercisecount) {
      
        var dynamic_ques1: any = new createjs.Text(writingtextarray[sb[yr3_exercisecount]], "35px MyriadPro-Regular", "#000000");
        dynamic_ques1.setTransform(650, 280);
        dynamic_ques1.name = "removeimage";

        var dynamic_ques2: any = new createjs.Text(writingtextarray1[sb[yr3_exercisecount]], "35px MyriadPro-Regular", "#000000");
        dynamic_ques2.setTransform(650, 330);
        dynamic_ques2.name = "removeimage";

        stage.addChild(dynamic_ques1, dynamic_ques2);


      }

      img_temprect2.addEventListener("click", function () {
        for (var j = 0; j < stage.children.length; j++) {
          if (stage.children[j].name == "removeimage") {
            stage.removeChild(stage.children[j]);
            j = j - 1;
          }
        }
        yr3_exercisecount = yr3_exercisecount + 1;
        if (yr3_exercisecount == 40) {
          yr3_exercisecount = 0;
          shuffle(sb, sb);  
          inspiration(yr3_exercisecount);
        } else {
          inspiration(yr3_exercisecount);
        }

      });
    }
    stage.addChild(yr3_bitmap, heading, heading_ipad, option_container, img_rect1, img_temprect1, img_rect2, img_temprect2);
    stage.enableMouseOver();
    createjs.Ticker.reset();
    createjs.Ticker.framerate = 60;
    createjs.Ticker.addEventListener("tick", this.stage);
    createjs.Ticker.addEventListener("tick", createjs.Tween);
    createjs.Ticker.timingMode = createjs.Ticker.RAF;
  }

  onCloseCancel() {
    createjs.Ticker.reset();
    createjs.Touch.disable(this.stage);
    createjs.Tween.removeAllTweens();
    this.stage.enableMouseOver(0);
    this.stage.clear();
    this.thisDialogRef.close('Cancel');
    let toggler: any = document.getElementById("toggler");
    if (toggler) {
      toggler.style.visibility = "visible";
    }
  }
}

